<div class="fundraising-container">

    <ngx-spinner
      bdColor="rgba(75, 55, 100, 0.5)"
      size="large"
      color="#fff"
      type="line-scale-pulse-out">
          <span class="chevron left"></span>
          <span class="chevron right"></span>
    </ngx-spinner>

      <div class="search-row align-center">
       <div class="input-with-icon align-row">
          <div class="input-icon align-center"><i class="flaticon-search"></i></div>
          <input
            type="text"
            placeholder="Search"
            (keyup)="search()"
            [(ngModel)]="searchText"
            class="searchtext"
        />
        </div>
        <div class="input-with-icon align-row">
            <select
                [(ngModel)]="selectedCampaign"
                (ngModelChange)="filterByCampaign()"
                class="searchtext">
                <option selected value='0'>
                    -- Filter payouts by Campaign --
                </option>
                <option *ngFor="let event of events; let i = index;" [value]="event.eventId">
                    {{ event.name }}
                </option>
            </select>
          </div>
      </div>
      <mat-expansion-panel *ngFor="let group of payoutGroups; let i = index;" class="fundraising-table" style="flex-direction: column; margin-bottom: 15px;">
        <mat-expansion-panel-header>
          <mat-panel-title style="color: #5e6383; font-family: Poppins; font-weight: 400; font-size: 1.5rem;">
            {{ group.group }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="panel-container">
          <div class="info-container" style="margin-top: 0;"></div>
          <div class="panel-table">
            <div class="data-row" style="box-shadow: 5px 5px 5px grey;" *ngFor="let payout of group.children">
              <div class="data-row-content" style="height: 100%;">
                <div class="content-cell" style="justify-content: space-between;">
                  <div class="cell-row" style="justify-content: space-between;">
                    <h3 class="fundraiser-title">{{ payout.event.name }}</h3>
                  </div>
                  <div class="cell-row">
                    <div style="height: 21px;"> </div>
                    <div style="cursor: help; padding-top: 8px;" container="body" tooltip="The funds from this event have been deposited in your bank account" *ngIf="payout.status === 'complete'" class="block-icon status grn"><span>PAYOUT COMPLETE</span></div>
                    <div style="cursor: help; padding-top: 8px;" container="body" tooltip="The funds from this event are scheduled to be deposited" *ngIf="payout.status === 'scheduled'" class="block-icon status blu"><span>PAYOUT SCHEDULED</span></div>
                    <div style="cursor: help; padding-top: 8px;" container="body" tooltip="Stripe is depositing these funds into your bank account" *ngIf="payout.status === 'pending'" class="block-icon status org"><span>PAYOUT PENDING</span></div>
                  </div>
                  <div class="cell-row">
                    <div>
                      <div class="info-container">
                        <span class="info-content">{{ payout.dateCreated | date:'M/d/yy' }}</span>
                        <span class="info-title">Date Created</span>
                      </div>
                      <div class="info-container">
                        <span class="info-content">{{ payout.amount / 100 | currency }}</span>
                        <span class="info-title">Amount</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <div *ngIf="!payoutGroups.length"> No Payouts to show</div>
    </div>
